
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    activeBodega: null,
    bodegas: [],
    isLoadingBodega: false,
    totalBodega: 0,
    
});






export const useBodegasStore = create()(
    devtools(
        storeApi
    )
)
